import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';

@Component({
  selector: 'app-visa-report',
  templateUrl: './visa-report.component.html',
  styleUrls: ['./visa-report.component.css']
})
export class VisaReportComponent implements OnInit {

  public menu_item_id = '107';

  private dp = [];
  displayedColumns = ['sr', 'invoice_no', 'trip_name', 'head_name', 'mobile', 'cont_type', 'country_name', 'visa_count'];

  model = {
    'trip_name': '', 'trip_number': '', 'trip_status': 'active', 'title': 'تقرير التأشيرات',
    'trip_id': '0', 'country_id': '', 'type_id': 'all'
  };

  today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

  search_prog = {
    'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`trip`', 'selected_no': 'trip_id',
      'field_list': ['trip_name', 'trip_number'],
      'condition': " AND `trip`.`arrival_date` >= '" + this.today + "'"
    }]
  };

  type_list = [{ 'type_id': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
  { 'type_id': 'program', 'type_name': 'عقود البرامج السياحية', 'type_name_en': 'Tourism Programs Contracts' },
  { 'type_id': 'special_prog', 'type_name': 'عقود البرامج الخاصة', 'type_name_en': 'Special Programs Contracts' }];

  country_list = [];

  dialog_data = [{ 'id': 'sr', 'title_ar': 'الرقم', 'title_en': 'Number', 'checked': '1' },
  { 'id': 'invoice_no', 'title_ar': 'رقم العقد', 'title_en': 'Contract Number', 'checked': '1' },
  { 'id': 'trip_name', 'title_ar': 'اسم البرنامج', 'title_en': 'Program Name', 'checked': '1' },
  { 'id': 'head_name', 'title_ar': 'رئيس المجموعة', 'title_en': 'Group Head', 'checked': '1' },
  { 'id': 'customer_name_en', 'title_ar': 'الاسم الإنجليزي', 'title_en': 'English Name', 'checked': '0' },
  { 'id': 'mobile', 'title_ar': 'رقم الجوال', 'title_en': 'Mobile', 'checked': '1' },
  { 'id': 'cont_type', 'title_ar': 'نوع العقد', 'title_en': 'Contract Type', 'checked': '1' },
  { 'id': 'country_name', 'title_ar': 'الدولة', 'title_en': 'Country', 'checked': '1' },
  { 'id': 'visa_count', 'title_ar': 'عدد التأشيرات', 'title_en': 'Visa Count', 'checked': '1' }];


  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;


  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  Visa_Report; Prog_Name; Prog_No; Program_Placeholder; Country_Msg;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Visa_Report').subscribe((res: string) => {
      this.Visa_Report = res;
    });
    this.model['title'] = this.Visa_Report;

    translate.get('Prog_Name').subscribe((res: string) => {
      this.Prog_Name = res;
    });

    translate.get('Prog_No').subscribe((res: string) => {
      this.Prog_No = res;
    });

    translate.get('Country_Msg').subscribe((res: string) => {
      this.Country_Msg = res;
    });

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    this.search_prog.placeholder = this.Program_Placeholder;

  }

  ngOnInit() {
    let query = this.queryList.all_country;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.country_list = data.data['list'];
      });

  }

  onChangeProg = function (search_result: object) {
    this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  changeStatus() {
    if (this.model['trip_status'] == 'active')
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` >= '" + this.today + "'";

    else
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` < '" + this.today + "'";
  }

  search() {

    if (this.model['country_id'] == '') {
      alert(this.Country_Msg);
      return;
    } 

    let obj = { cmd: 'getVisaRep' };

    obj['type_id'] = this.model['type_id'];

    if (this.model['type_id'] == 'program' && this.model['trip_id'] != '0')
      obj['trip_id'] = this.model['trip_id'];

    if (this.model['country_id'] != '')
      obj['country_id'] = this.model['country_id'];

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = [];
          
          this.dialog_data.forEach(element => {
            if (element.checked == '1')
              this.displayedColumns.push(element.id);
          });
        }
      });

  }


  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Visa_Report + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
